module.exports = __webpack_public_path__ + "static/full01-c68bfa33d1b92a7dcd38a34d32f69846.png";